<template>
	<div v-if="places.length">
		<div v-if="persons.length">
			<v-speed-dial
				v-model="fab"
				fab
				absolute
				:direction="'right'"
				:transition="'slide-y-reverse-transition'"
			>
				<template v-slot:activator>
					<v-btn v-model="fab" color="primary " dark fab>
						<v-icon v-if="fab">
							mdi-close
						</v-icon>
						<v-icon v-else>
							mdi-chart-timeline
						</v-icon>
					</v-btn>
				</template>
				<div v-if="persons.length" style="width: 60px">
					<v-tooltip color="warning" bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-bind="attrs"
								v-on="on"
								fab
								small
								color="success"
								@click.stop="menuLodTab = true"
							>
								<v-icon small>mdi-chart-timeline</v-icon>
							</v-btn>
						</template>
						<span>Cree actividades en el cuadro superior.</span>
					</v-tooltip>
				</div>
				<div v-if="persons.length" style="width: 50px">
					<v-tooltip color="warning" bottom v-if="lodgingPerLabel.length">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								small
								v-bind="attrs"
								v-on="on"
								color="info"
								@click.stop="moveTimeline('left')"
							>
								<v-icon left>mdi-arrow-left</v-icon>
							</v-btn>
						</template>
						<span>Mueva el cronograma hacia la izquierda.</span>
					</v-tooltip>
				</div>
				<div v-if="persons.length" style="width: 50px">
					<v-tooltip color="warning" bottom v-if="lodgingPerLabel.length">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-bind="attrs"
								v-on="on"
								small
								fab
								color="info"
								@click.stop="moveTimeline('right')"
							>
								<v-icon right>mdi-arrow-right</v-icon>
							</v-btn>
						</template>
						<span>Mueva el cronograma hacia la derecha.</span>
					</v-tooltip>
				</div>
			</v-speed-dial>
			<div style="padding-left:100px">
				<v-checkbox
					dense
					hide-details
					small
					v-model="horaOactividad"
					label="Ordenar por actividades y no por hora"
				>
				</v-checkbox>
			</div>

			<div style="min-height: 500px" class="overflow-x-auto" id="scrollItems">
				<!-- Espacio de mes, persona y flechas -->
				<div style="width: 1200px;" class="d-flex " id="scrollItems">
					<div v-if="persons.length" style="width: 100px"></div>

					<div v-if="persons.length" style="width:220px">
						<v-text-field
							dense
							filled
							solo
							outlined
							small
							label="Mes a visualizar"
							hide-details
							:loading="changeMonth"
							loader-height="4"
							color="info"
							type="month"
							v-model="mes"
						></v-text-field>
					</div>

					<div v-if="persons.length" style="width: 240px">
						<v-text-field
							dense
							filled
							solo
							outlined
							hide-details
							append-icon="mdi-magnify"
							label="Buscar por técnicoo"
							class="mx-2"
							@input="filter"
						></v-text-field>
					</div>
					<div v-if="places.length" style="width: 240px">
						<v-text-field
							dense
							filled
							solo
							outlined
							hide-details
							append-icon="mdi-magnify"
							label="Buscar por cliente"
							class="mx-2"
							v-model="filtroCliente"
						></v-text-field>
					</div>
					<div v-if="persons.length" style="width: 500px" class="">
						<v-radio-group
							row
							hide-details
							v-model="toggleIcons"
							class="d-flex mt-0 pt-0"
						>
							<v-radio :label="'Ver actividades'" :value="'1'" />
							<v-radio :label="'Ver notificaciones'" :value="'2'" />
							<v-radio :label="'Ver asistencia'" :value="'3'" />
						</v-radio-group>
					</div>
				</div>

				<!-- Espacio de fechas -->
				<div style="width: 1200px;" class="d-flex" id="scrollItems">
					<div style="min-width: 300px" class="bb"></div>

					<div style="width: 100%" class="">
						<div class="overflow-x-auto	">
							<div>
								<div class="d-flex">
									<div
										v-for="(date, idRangeDate) in rangeDateTable"
										:key="idRangeDate + 'idRangeDate2'"
										class="itemDateHead bt bb bl"
										:class="{
											br: idRangeDate == rangeDateTable.length - 1,
											itemEmptyToday: verifyItemEmptyToday(date.numberDay),
											itemEmptyWeekend:
												date.initialDay == 'sá' ||
												(date.initialDay == 'do' &&
													!verifyItemEmptyToday(date.numberDay)),
										}"
									>
										{{ date.initialDay }}
									</div>
								</div>
								<div class="d-flex">
									<div
										v-for="(date, idRangeDate) in rangeDateTable"
										:key="idRangeDate + 'idRangeDate3'"
										class="itemDateHead bb bl "
										:class="{
											br: idRangeDate == rangeDateTable.length - 1,
											itemEmptyToday: verifyItemEmptyToday(date.numberDay),
											itemEmptyWeekend:
												date.initialDay == 'sá' ||
												(date.initialDay == 'do' &&
													!verifyItemEmptyToday(date.numberDay)),
										}"
									>
										{{ date.nameDay }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div>
					<div
						class="text-left overflow-y-auto"
						style="min-width:1250px; width:1250px; max-height: 500px; height: 500px"
					>
						<div
							v-for="(lod, lodIndex) in lodgingPerLabel"
							:key="lodIndex + 'horizontalPerson'"
						>
							<div v-if="lod.personasPorActividad.length">
								<div class="d-flex">
									<div style="min-width: 300px; max-width: 300px;" class="bb">
										<span class="title-place px-2 text-uppercase">{{
											lod.place.text
										}}</span>
										<br />
										<span class="title-no-act px-2">{{ lod.label }}</span>
									</div>
									<div
										v-for="(date, idRangeDate) in rangeDateTable"
										:key="idRangeDate + 'idRangeDateLabel'"
										style="min-width: 30px; max-width: 30px; background-color: white;"
										:class="{
											bl: idRangeDate == 0,
											br: idRangeDate == rangeDateTable.length - 1,
											itemEmptyToday: verifyItemEmptyToday(date.numberDay),
											itemEmptyWeekend:
												date.initialDay == 'sá' ||
												(date.initialDay == 'do' &&
													!verifyItemEmptyToday(date.numberDay)),
										}"
										class="itemEmptyLabel bb"
									></div>
								</div>

								<div
									v-for="(personActivity,
									personActivityIndex) in lod.personasPorActividad"
									:key="personActivityIndex + 'horizontalPerson'"
								>
									<div class="d-flex">
										<div style="min-width:300px; max-width:300px" class="bb">
											<span style="font-size: 12px">
												<span class="text-uppercase">
													{{ personActivity.persona.firstName }}
													{{
														personActivity.persona.lastName
															? personActivity.persona.lastName
															: ''
													}}
												</span>
												<br />
												{{
													personActivity.persona.rut
														? personActivity.persona.rut
														: 'Sin RUT'
												}}
												{{ ' ' }}
												{{
													personActivity.persona.appointment
														? personActivity.persona.appointment
														: 'Sin cargo'
												}}
											</span>
										</div>

										<div
											v-for="(date, idRangeDate) in rangeDateTable"
											:key="idRangeDate + 'idRangeDate3'"
											:class="{
												br: idRangeDate == rangeDateTable.length - 1,
												itemDateHeadBorderDark: $vuetify.theme.isDark,
												itemDateHeadBorderLigth: !$vuetify.theme.isDark,
												itemEmptyWeekend:
													(date.initialDay == 'sá' ||
														date.initialDay == 'do') &&
													!verifyItemEmptyTodayPerson({
														person: personActivity.persona,
														date,
													}),
												itemEmptyToday: verifyItemEmptyTodayPerson({
													person: personActivity.persona,
													date,
												}),
												itemEmptySelected:
													itemEmptySelected ==
													lod.place._id +
														lod.label +
														idRangeDate +
														personActivity.persona._id,
											}"
											class="itemEmpty bb bl"
											style="min-width: 30px; max-width: 30px"
											@click.capture="
												openItemEmpty({
													dateAlltimeline: date,
													person: [personActivity.persona._id],
													group: lod.label,
													place: lod.place._id,
													indexDate: idRangeDate,
												})
											"
										>
											<span
												v-for="(actividadLabel,
												actividadLabelIndex) in personActivity.actividadesPorPersonaLabel"
												:key="actividadLabelIndex + 'actividadLabelIndex'"
											>
												<span
													v-if="
														compareDates({
															start: actividadLabel.start,
															end: actividadLabel.end,
															dayTable: date.numberDay,
														})
													"
												>
													<details-lodging
														:periodSelected="periodSelected"
														:periods="itemsPeriods"
														:toggleIconsLabel="toggleIcons == '2'"
														:toggleIconsAssistance="toggleIcons == '3'"
														:lodging="{ ...actividadLabel }"
														:date="date"
														:compareDates="compareDates"
														:editLodging="editLodging"
													/>
												</span>
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<v-menu
				v-model="menuLodTab"
				:close-on-content-click="false"
				:nudge-width="300"
				offset-x
			>
				<lodging-tabs :close="() => editLodging('close')" v-if="lodgingTab" />
			</v-menu>
			<div>
				<list-worker-visit />
			</div>
			<!-- <v-skeleton-loader v-else type="table" height="359" width="90%" class="mx-auto my-6" /> -->
			<!-- <v-col v-else cols="12">
				<data-empty
					:title="`Sin actividades este mes.`"
					:msj="`Selecione un mes diferente o cree actividades`"
				/>
			</v-col> -->
		</div>
		<div v-else>
			<v-col cols="12">
				<v-dialog
					v-model="dialogPerson"
					transition="dialog-bottom-transition"
					max-width="800"
				>
					<v-card>
						<v-toolbar color="primary" flat dark>
							Nueva persona
							<v-spacer></v-spacer>
							<v-btn text fab @click="dialogPerson = false">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-toolbar>
						<v-card-text>
							<createPerson :close="() => (dialogPerson = false)" />
						</v-card-text>
					</v-card>
				</v-dialog>
				<data-empty
					title="Sin personas registradas"
					msj="Para ver y crear actividades deben existir personas bajo su gestión"
				/>
				<v-tooltip color="warning" bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							class="my-2 mx-2 "
							color="success"
							x-small
							@click="dialogPerson = true"
						>
							<v-icon left>mdi-plus</v-icon>
							<v-icon small left>mdi-account-circle-outline</v-icon>
						</v-btn>
					</template>
					<span>Agregar personas a mi gestión.</span>
				</v-tooltip>
			</v-col>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
// import { cloneDeep } from 'lodash';

let moment = extendMoment(Moment);

export default {
	name: 'AllActivities',
	components: {
		DataEmpty: () => import('@/components/ui/DataEmpty'),
		DetailsLodging: () => import('@/components/lodgings/DetailsLodging'),
		LodgingTabs: () => import('@/components/lodgings/LodgingTabs'),
		createPerson: () => import('@/components/persons/CreatePerson'),
		ListWorkerVisit: () => import('@/components/persons/ListWorkerVisit'),
	},
	data() {
		return {
			filtroCliente: '',
			horaOactividad: false,
			changeMonth: false,
			fav: true,
			menuLodTab: false,
			message: false,
			hints: true,
			fab: false,
			fling: false,
			tabs: null,
			itemEmptySelected: '',
			placeIndexSelect: null,
			moveTimelineNumber: 0,
			dialogPerson: false,
			expandHelp: false,
			toggleCost: false,
			toggleIcons: '1',
			lodgingTab: true,
			containerScroll: null,
			filterPerson: '',
			itemsPeriods: [],
			periodSelected: '',
			sortLabel: [],
			colors: [
				'red',
				'blue',
				'green',
				'indigo',
				'purple',
				'teal',
				'orange',
				'brown',
				'deep-orange',
				'blue-grey',
				'cyan',
			],
			listadoPersonasFiltradas: [],
		};
	},
	computed: {
		mes: {
			get: function() {
				return this.month;
			},
			set: function(newValue) {
				this.setMonth(newValue);
			},
		},
		lodgingPerLabel() {
			let lodgingFilterLabel = [];
			if (this.persons.length)
				this.labelAvalaibles.forEach(label => {
					let personasPorActividad = [];
					let existieronActividades = false;
					let cantActividades = 0;

					this.listadoPersonasFiltradas.forEach(p => {
						let actividadesPorPersonaLabel = this.filterLodgings.filter(
							l =>
								l.group == label.text &&
								label.place._id == l.place &&
								p._id == l.person
						);
						cantActividades += actividadesPorPersonaLabel.length;
						if (actividadesPorPersonaLabel.length > 0) {
							existieronActividades = true;
							personasPorActividad.push({
								persona: p,
								actividadesPorPersonaLabel: actividadesPorPersonaLabel,
							});
						}
					});
					const placeExist = lodgingFilterLabel.find(p => p.place == label.place);
					if (existieronActividades)
						lodgingFilterLabel.push({
							personasPorActividad: personasPorActividad,
							label: label.text,
							sortNumber: label.sortNumber,
							place: label.place,
							cantidadTotalActividades: cantActividades,
						});
					if (!existieronActividades && !placeExist)
						lodgingFilterLabel.push({
							personasPorActividad: personasPorActividad,
							label: label.text,
							sortNumber: label.sortNumber,
							place: label.place,
							cantidadTotalActividades: cantActividades,
						});
				});
			if (!this.horaOactividad) {
				lodgingFilterLabel = lodgingFilterLabel.sort(
					(actividadesA, actividadesB) => actividadesB.label - actividadesA.label
				);
			} else {
				lodgingFilterLabel = lodgingFilterLabel.sort(
					(actividadesA, actividadesB) =>
						actividadesB.cantidadTotalActividades -
						actividadesA.cantidadTotalActividades
				);
			}

			return lodgingFilterLabel;
		},
		labelAvalaibles() {
			let placesFiltrados = [];
			let labelNames = [];
			if (this.filtroCliente)
				placesFiltrados = this.places.filter(p => {
					return !p.text.toUpperCase().indexOf(this.filtroCliente.toUpperCase());
				});
			else placesFiltrados = this.places;
			placesFiltrados.forEach(p => {
				if (!labelNames.some(group => group.value == 'Sin periodo' && group.place == p._id))
					labelNames.push({
						value: 'Sin periodo',
						text: 'Sin periodo',
						sortNumber: -1,
						place: p,
					});
				let newIndex = 0;

				this.filterLodgings.forEach(lod => {
					if (lod.group)
						if (
							!labelNames.some(
								group => group.value == lod.group && group.place._id == p._id
							)
						) {
							labelNames.push({
								value: lod.group,
								text: lod.group,
								sortNumber: newIndex,
								place: p,
							});
							newIndex++;
						}
				});

				labelNames.forEach(ln => {
					if (this.sortLabel.length > 0) {
						let sls = this.sortLabel.find(sl => sl.name == ln.text);
						if (sls) ln.sortNumber = sls.count;
					}
				});
				labelNames = labelNames.sort((a, b) => {
					if (a.text > b.text) return 1;
					if (a.text < b.text) return -1;
					return 0;
				});
			});
			return labelNames;
		},
		zTotal() {
			let total = 0;
			this.lodgingPerLabel.forEach(lpl => {
				lpl.persons.forEach(
					person => (total += person.totalDaysMonth * lpl.lodgings[0].service.price)
				);
			});
			return total;
		},
		filterLodgings() {
			if (this.allLodgings.length)
				return this.allLodgings.filter(
					lod =>
						(moment(lod.start).isBefore(moment(this.rangeDate.start)) &&
							moment(lod.end).isSameOrAfter(moment(this.rangeDate.start))) ||
						(moment(lod.end).isAfter(moment(this.rangeDate.end)) &&
							moment(lod.start).isSameOrBefore(moment(this.rangeDate.end))) ||
						(moment(lod.start).isSameOrAfter(moment(this.rangeDate.start)) &&
							moment(lod.end).isSameOrBefore(moment(this.rangeDate.end)))
				);
			else return [];
		},
		rangeDateTable() {
			let dates = [];
			if (!this.rangeDate.end || !this.rangeDate.start) return dates;
			let numberDays = this.rangeDate.end.diff(this.rangeDate.start, 'days');
			for (let i = 0; i <= numberDays; i++)
				dates.push({
					numberDay: moment(this.rangeDate.start)
						.add(i, 'day')
						.format('YYYY-MM-DD'),
					nameDay: moment(this.rangeDate.start)
						.add(i, 'day')
						.format('DD'),
					initialDay: moment(this.rangeDate.start)
						.add(i, 'day')
						.format('dd'),
					dateMoment: moment(this.rangeDate.start).add(i, 'day'),
				});
			return dates;
		},
		...mapGetters({
			places: 'Lodging/places',
			itemEmpty: 'Lodging/itemEmpty',
			loadingLodgings: 'Lodging/loadingLodgings',
			lodgings: 'Lodging/lodgings',
			allLodgings: 'Lodging/allLodgings',
			lodgingSelect: 'Lodging/lodgingSelect',
			persons: 'Person/persons',
			rangeDate: 'Lodging/rangeDate',
			selectedPlace: 'Lodging/selectedPlace',
			selectedService: 'Lodging/selectedService',
			month: 'Lodging/month',
		}),
	},
	watch: {
		menuLodTab(newVal) {
			if (!newVal) this.editLodging('close');
		},
		async month(newVal) {
			this.changeMonth = true;
			await this.getLodgingsOfAdmin();
			this.setRangeDate({
				start: moment(newVal).date(1),
				end: moment(newVal)
					.clone()
					.endOf('month'),
			});
			this.changeMonth = false;
		},
		filterLodgings() {
			this.setItemsPeriods();
		},
		persons() {
			this.setItemsPeriods();
			this.setListadoPersonasFiltradas();
		},
	},
	async mounted() {
		if (this.month)
			this.setRangeDate({
				start: moment(this.month).date(1),
				end: moment(this.month)
					.clone()
					.endOf('month'),
			});
		this.setItemsPeriods();
		this.setListadoPersonasFiltradas();
	},

	methods: {
		async openItemEmpty(payload) {
			this.itemEmptySelected =
				payload.place + payload.group + payload.indexDate + payload.person[0];
			await this.reloadLodgingTab();
			this.setModeEdit(true);
			let place = this.places.find(place => place._id == payload.place);
			this.setSelectedPlace(place._id);
			this.selectServices(place.services[0]);
			this.selectItemEmpty(payload);
			this.menuLodTab = true;
		},
		reloadLodgingTab() {
			this.lodgingTab = false;
			setTimeout(() => (this.lodgingTab = true), 1);
		},
		getStatusPerson(person) {
			if (person)
				if (!person.documents && person.typeDocument.length) {
					return 'error';
				} else {
					if (person.typeDocument.some(doc => doc != null && doc.done == false))
						return 'warning';
					else return 'success';
				}
			else return '';
		},
		moveTimeline(dir) {
			if (dir == 'left' && this.moveTimelineNumber >= 50)
				this.moveTimelineNumber = this.moveTimelineNumber - 50;
			if (
				dir == 'right' &&
				this.moveTimelineNumber < 650 &&
				!this.$vuetify.breakpoint.lgAndUp
			)
				this.moveTimelineNumber = this.moveTimelineNumber + 50;
			if (dir == 'right' && this.moveTimelineNumber < 450 && this.$vuetify.breakpoint.lgAndUp)
				this.moveTimelineNumber = this.moveTimelineNumber + 50;

			this.containerScroll = this.$el.querySelector('#scrollItems');
			if (this.containerScroll) this.containerScroll.scrollLeft = this.moveTimelineNumber;
		},
		setItemsPeriods() {
			this.itemsPeriods = [];
			this.filterLodgings.forEach(item => {
				if (item.room && !this.itemsPeriods.some(el => el.period == item.room))
					this.itemsPeriods.push({ period: item.room });
				// Establece el color de los periodos
				// El counter maximo debe ser hasta numero de colores en this.colors
				let counter = 0;
				this.itemsPeriods = this.itemsPeriods.map(el => {
					const element = { period: el.period, color: this.colors[counter] };
					counter == 10 ? (counter = 0) : counter++;
					return element;
				});
			});
		},
		personsFind(person, searchList) {
			let itemText = person.firstName + person.lastName + person.rut;
			itemText = itemText.toLowerCase();
			let count = 0;
			searchList.forEach(b => {
				if (itemText.indexOf(b) > -1) count++;
			});
			return searchList.length === count;
		},
		moveLabel(dir, index, name) {
			if (!this.sortLabel.some(s => s.name == name)) this.sortLabel.push({ name });
			this.sortLabel = this.sortLabel.map(item => {
				if (dir == 'up' && item.name == name)
					item.count
						? item.count >= 0
							? (item.count -= 1)
							: null
						: (item.count = index - 1);
				if (dir == 'down' && item.name == name)
					item.count ? (item.count += 1) : (item.count = index + 1);
				return {
					name: item.name,
					count: item.count,
				};
			});
		},
		verifyItemEmptyToday(numberDay) {
			const today = moment().format('YYYY-MM-DD');
			if (moment(today).isSame(moment(numberDay))) return true;
			else return false;
		},
		verifyItemEmptyTodayPerson(payload) {
			const today = moment().format('YYYY-MM-DD');
			if (this.itemEmpty) {
				return (
					(payload.person._id == this.itemEmpty.person._id &&
						payload.date.numberDay == this.itemEmpty.date.numberDay) ||
					moment(today).isSame(moment(payload.date.numberDay))
				);
			} else {
				if (moment(today).isSame(moment(payload.date.numberDay))) return true;
				else return false;
			}
		},
		selectPeriod(period) {
			this.periodSelected = this.periodSelected ? '' : period;
		},
		editLodging(lodging) {
			if (lodging == 'close') {
				this.menuLodTab = false;
				this.setModeEdit(false);
				this.setLodgingSelect(null);
				this.setSelectedPlace(null);
				this.selectServices(null);
				this.selectItemEmpty(null);
				setTimeout(() => {
					//DEJARA ACTIVO EL COLOR ROJO EN EL ITEM PARA Q EL USER LO VEA
					this.setLodgingWithProblems(null);
				}, 8000);
				this.reloadLodgingTab();
			} else {
				let place = this.places.find(place => place._id == lodging.place);
				this.setSelectedPlace(place._id);
				this.setModeEdit(true);
				this.setLodgingSelect(lodging);
				this.selectServices(place.services[0]);
				this.setLodgingWithProblems(null);
				this.reloadLodgingTab();
			}
		},
		compareDates(payload) {
			if (payload.text) {
				return (
					(moment(payload.start).month() !==
						moment(this.rangeDateTable[0].numberDay).month() &&
						moment(payload.dayTable).isSame(
							moment(this.rangeDateTable[0].numberDay)
						)) ||
					moment(payload.dayTable).isSame(moment(payload.start))
				);
			} else {
				return (
					moment(payload.dayTable).isSameOrAfter(moment(payload.start)) &&
					moment(payload.dayTable).isSameOrBefore(moment(payload.end))
				);
			}
		},
		setListadoPersonasFiltradas() {
			this.listadoPersonasFiltradas = this.persons;
		},
		filter(word) {
			if (word.length >= 1) this.listadoPersonasFiltradas = this.filterName(word);
			if (word.length == 0) this.listadoPersonasFiltradas = this.persons;
		},
		filterName(word) {
			return this.persons.filter(
				persona => persona.firstName.toLowerCase().indexOf(word.toLowerCase()) > -1
			);
		},
		...mapActions({
			getLodgingsOfAdmin: 'Lodging/getLodgingsOfAdmin',
		}),
		...mapMutations({
			selectItemEmpty: 'Lodging/selectItemEmpty',
			setLodgingWithProblems: 'Lodging/setLodgingWithProblems',
			setModeEdit: 'Lodging/setModeEdit',
			setRangeDate: 'Lodging/setRangeDate',
			setLodgingSelect: 'Lodging/setLodgingSelect',
			setSelectedPlace: 'Lodging/setSelectedPlace',
			selectServices: 'Lodging/selectServices',
			setMonth: 'Lodging/setMonth',
		}),
	},
};
</script>

<style lang="scss" scoped>
.bb-place {
	border-bottom: 1px solid black;
}
.bb {
	border-bottom: 1px solid gray;
}
.br {
	border-right: 1px solid gray;
}
.bt {
	border-top: 1px solid gray;
}
.bl {
	border-left: 1px solid gray;
}
.title-no-act {
	font-size: 10px;
	font-weight: 600;
	border-radius: 3px;
	background-color: gray;
	color: white;
}

.title-place {
	font-size: 10px;
	font-weight: 600;

	border-radius: 3px;
	background-color: #db3005;
	color: white;
}
.itemEmptySelected {
	border: 1px solid #6b31ff !important;
}

.v-icon {
	position: static !important;
}
.labelMaxWidth {
	width: max-content;
}
.itemEmptyLabel {
	width: 30px;
	background-color: #477a8621;
}
.itemEmpty:hover {
	background-color: orange !important;
}

.itemEmptyToday {
	background-color: #8a898d !important;
}
.itemEmptyWeekend {
	background-color: #80808059 !important;
}
.itemTotal div {
	display: inline-block;
	width: 60%;
	height: 25px;
}
.itemNamePeriodSelect {
	border: 2px solid #ad1f98 !important;
	border-radius: 25px;
}

.itemPerson {
	height: 25px;
	width: max-content;
	text-align: left;
	font-size: 12px;
	line-height: 13px;
	background-color: transparent;
}
.nameMonth {
	width: 300px;
	text-align: left;
}
.itemEmpty {
	width: 30px;
	background-color: #477a8621;
}
.itemDateHead {
	min-width: 30px;
	max-width: 30px;
	height: 25px;
}
/* This is for documentation purposes and will not be needed in your application */
#create .v-speed-dial {
	position: absolute;
}

#create .v-btn--floating {
	position: relative;
}
</style>
